import React from 'react';
import {Box} from '@mui/material';
import {Panel} from '../Panel/Panel';
import {themeColors} from '../../theme/Theme';
import {ContactVulnerabilitiesTable} from '../../features/vulnerabilities/ContactVulnerabilitiesTable';
import {useVulnerabilityOptions} from '../../features/vulnerabilities/useVulnerabilityOptions';
import {ContactPageQuery_contactDetails} from '../../schema-types/ContactPageQuery';
import {getContactName} from '../../utils/getContactName';

/**
 * Contact page "Vulnerabilities" panel (DBO-766): the contact's active Curo
 * vulnerability rows, with add / edit syncing to Curo at once for every
 * proposition. The contact needs a linked account, because Curo requires one on
 * each row.
 */
export const ContactVulnerabilities: React.FC<{
  contact: ContactPageQuery_contactDetails;
}> = ({contact}) => {
  const options = useVulnerabilityOptions();
  if (options.loading || !options.isEnabled) {
    return null;
  }

  const accounts = (contact.accountContacts || []).map((link) => link.account);
  const accountId: string | undefined = accounts[0]?.id;
  const readOnly = !accountId;

  return (
    <Panel title="Vulnerabilities" color={themeColors.coral}>
      <Box mt={2} />
      <ContactVulnerabilitiesTable
        accountId={accountId || ''}
        contact={{id: contact.id, simplifiedName: getContactName(contact)}}
        options={options}
        readOnly={readOnly}
        hideContactName
      />
    </Panel>
  );
};
